import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import s from './Price.module.scss'

export default function Price({ discount, regularPrice, price }) {
  const { t } = useTranslation()

  if (!price && !regularPrice) return null

  return (
    <div className={s.price}>
      <div className={classNames(s['price-info'], s['regular-price'])}>
        <div className={s.label}>{t('price.regular')}:</div>
        <div className={s.value}>{regularPrice} €</div>
      </div>
      <div className={classNames(s['price-info'], s.discount)}>
        <div className={s.label}>{t('price.giftCard')}:</div>
        <div className={s.value}>{discount} €</div>
      </div>
      <div className={classNames(s['price-info'], s.total)}>
        <div className={s.label}>{t('price.total')}:</div>
        <div className={s.value}>{price} €</div>
      </div>
    </div>
  )
}

Price.propTypes = {
  discount: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  regularPrice: PropTypes.number
}
